<template>
  <div class="search-form">
    <div class="d-flex">
      <div style="width:350px;" class="mb-2">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            placeholder="调度订单/订单/运单/(ERP/WMS单号)/销售订单号..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  高级搜索
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="mb-2">
        <b-input-group>
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="batchIsPickUp()"
          >
            <i class="el-icon-box"></i>
            批量提货
          </b-button>
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="batchIsReceive()"
          >
            <i class="el-icon-takeaway-box"></i>
            批量送达
          </b-button>
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="batchDetailPrint()"
          >
            <i class="el-icon-printer"></i>
            批量打印
          </b-button>
          <b-button
            size="sm"
            variant="outline-primary"
            class="ml-2"
            @click="batchServiceFeedback()"
          >
            <i class="el-icon-service"></i>
            客服反馈
          </b-button>
          <b-button
            size="sm"
            variant="outline-danger"
            class="ml-2"
            @click="batchAbnormalRegister()"
          >
            <i class="el-icon-warning-outline"></i>
            异常登记
          </b-button>
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="$emit('batchExport')"
          >
            <i class="el-icon-folder-opened"></i>
            批量导出
          </b-button>
        </b-input-group>
      </div>
    </div>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="105px"
        size="small"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="订单编号">
              <el-input
                v-model="form.orderNo"
                placeholder="请输入订单编号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调度订单编号">
              <el-input
                v-model="form.dispatchOrderNo"
                placeholder="请输入调度订单编号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="运单编号">
              <el-input
                v-model="form.waybillNo"
                placeholder="请输入运单编号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="ERP/WMS单号">
              <el-input
                v-model="form.bizBillNo"
                placeholder="请输入ERP/WMS单号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="销售订单号">
              <el-input
                v-model="form.orderSoNo"
                placeholder="请输入销售订单号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="客户名称">
              <dict-select
                style="width:100%"
                clearable
                filterable
                v-model="form.custCode"
                url="/master/customer/info/select"
                placeholder="请选择客户"
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="订单类型">
              <dict-select
                filterable
                clearable
                v-model="form.orderType"
                placeholder="请选择订单类型"
                default
                :body="orderTypeDictParams"
                size="small"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="运输状态">
              <el-select
                v-model="form.bizStatusList"
                placeholder="请选择运输状态"
                multiple
                filterable
                clearable
                style="width:100%"
              >
                <el-option value="1" label="待提货"></el-option>
                <el-option value="2" label="待送达"></el-option>
                <el-option value="3" label="待回单"></el-option>
                <el-option value="4" label="回单待审核"></el-option>
                <el-option value="5" label="回单已拒绝"></el-option>
                <el-option value="6" label="待完成"></el-option>
                <el-option value="8" label="已完成"></el-option>
                <el-option value="9" label="拒收"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="异常状态">
              <el-checkbox-group v-model="form.isAbnormalList">
                <el-checkbox label="Y" name="type">异常</el-checkbox>
                <el-checkbox label="N" name="type">无</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  bizStatusList: [],
  isAbnormalList: [],
}
export default {
  data() {
    return {
      orderTypeDictParams: { type: 'orderType' },
      form: { ...initForm },
      advqueryDialogVisible: false,
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    batchIsPickUp() {
      this.$emit('batchIsPickUp')
    },
    batchIsReceive() {
      this.$emit('batchIsReceive')
    },
    batchDetailPrint() {
      this.$emit('batchDetailPrint')
    },
    batchServiceFeedback() {
      this.$emit('batchServiceFeedback')
    },
    batchAbnormalRegister() {
      this.$emit('batchAbnormalRegister')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
